import HRMService from "../services/HRMService";
import { to } from "../../utils";
// import _ from "../../compat/lodashplus";
export default class HRMManager {

  hrmService: any;
  constructor() { 
    this.hrmService = new HRMService();
  }
  getProviderInfo = async ({ apiToken, userId } = {}) => {
    let params: any = {};
  
    const [error, response, network] = await to(
      this.hrmService.getProviderInfo({
        apiToken,
        userId,
        params
      })
    );
    return [response, error, network];
  };
}
